import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() {
    return ["form", "preview"]
  }

  static get values() {
    return { previewUrlBase: String, signalId: Number }
  }

  connect() {
    this.fetchPreview()
    this.previewTarget.addEventListener("turbo:frame-load", () => {
      this.previewTarget.classList.remove("is-loading")
    })
  }

  fetchPreview() {
    const formData = new FormData(this.formTarget)
    const url = new URL(this.previewUrlBaseValue, window.location.origin)
    for (const [key, value] of formData) {
      url.searchParams.append(key, value)
    }
    if (this.signalIdValue) {
      url.searchParams.append("id", this.signalIdValue)
    }

    this.previewTarget.src = url.toString()
    this.previewTarget.classList.add("is-loading")
    this.previewTarget.reload()
  }
}
